import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface AreasSectionSkeletonProps {
  containerClassName?: string;
}

const AreasSectionSkeleton: React.FC<AreasSectionSkeletonProps> = ({
  containerClassName = '',
}) => {
  // Create skeleton for 4-8 gauge charts (typical range)
  const skeletonItems = Array.from({ length: 6 }, (_, index) => (
    <div key={index} className="flex flex-col items-center">
      {/* Gauge chart skeleton - circular */}
      <div className="relative w-24 h-24 mb-2">
        <Skeleton circle height={96} width={96} />
      </div>
      
      {/* Category name skeleton */}
      <div className="text-center max-w-20">
        <Skeleton height={12} width={60} />
      </div>
    </div>
  ));

  return (
    <div className="mt-8">
      <div className={`mt-6 ${containerClassName}`}>
        <div className="grid grid-cols-4 gap-4">
          {skeletonItems}
        </div>
      </div>
    </div>
  );
};

export default AreasSectionSkeleton;
